import { useTranslation } from "react-i18next";
import { Grid, Row, Col } from "rsuite";
import ShortCutPanel, { types } from "../components/ShortcutPanel";
import PeoplesIcon from "@rsuite/icons/Peoples";
import ReloadIcon from "@rsuite/icons/Reload";
import BellO from "@rsuite/icons/legacy/BellO";
import { Icon } from "@rsuite/icons";
import { AiOutlineUserAdd } from "react-icons/ai";
import {
  BsDatabaseCheck,
  BsShieldLock,
  BsClipboardCheck,
  BsPersonBadge,
} from "react-icons/bs";
import { MdOutlineDevices } from "react-icons/md";
import { useAuth } from "../context/AuthContext";
import { can, CAPABILITIES } from "../util/Permissions";

const AdminShortcuts = () => {
  const [t] = useTranslation();
  const { user } = useAuth() ?? {};

  // Declared as data so the grid can lay out only the tiles this operator is
  // actually allowed to open, without a wall of conditional JSX.
  const shortcuts = [
    {
      key: "users",
      capability: CAPABILITIES.usersManage,
      title: t("main-sidebar.users"),
      href: "/admin/users",
      icon: <PeoplesIcon />,
    },
    {
      key: "new-user",
      capability: CAPABILITIES.usersManage,
      title: t("main-sidebar.new-user"),
      href: "/admin/new-user",
      icon: <Icon as={AiOutlineUserAdd} />,
    },
    {
      key: "login-attempts",
      capability: CAPABILITIES.loginAttemptsView,
      title: t("main-sidebar.login-attempts"),
      href: "/admin/login-attempts",
      icon: <Icon as={BsShieldLock} />,
    },
    {
      key: "audit",
      capability: CAPABILITIES.auditView,
      title: t("main-sidebar.audit-log"),
      href: "/admin/audit",
      icon: <Icon as={BsClipboardCheck} />,
    },
    {
      key: "sessions",
      capability: CAPABILITIES.sessionsManage,
      title: t("main-sidebar.active-sessions"),
      href: "/admin/sessions",
      icon: <Icon as={MdOutlineDevices} />,
    },
    {
      key: "permissions",
      capability: CAPABILITIES.permissionsManage,
      title: t("main-sidebar.permissions"),
      href: "/admin/permissions",
      icon: <Icon as={BsPersonBadge} />,
    },
    {
      key: "alarm-recipients",
      capability: CAPABILITIES.alarmsManage,
      title: t("main-sidebar.alarm-recipients"),
      href: "/admin/alarm-recipients",
      icon: <BellO />,
    },
    {
      key: "services",
      capability: CAPABILITIES.servicesControl,
      title: t("main-sidebar.service-control"),
      href: "/admin/services",
      icon: <ReloadIcon />,
    },
    {
      key: "core-logs",
      capability: CAPABILITIES.servicesLogs,
      title: t("main-sidebar.check-core-api-logs"),
      href: "/admin/core-logs",
      icon: <Icon as={BsDatabaseCheck} />,
    },
    {
      key: "cmd-logs",
      capability: CAPABILITIES.servicesLogs,
      title: t("main-sidebar.check-cmd-api-logs"),
      href: "/admin/cmd-logs",
      icon: <Icon as={BsDatabaseCheck} />,
    },
  ].filter((shortcut) => can(user, shortcut.capability));

  // Rounded corners only belong on the ends of each three-up row.
  const edgeClass = (index) => {
    const position = index % 3;
    if (position === 0) return "content-init";
    if (position === 2) return "content-end";
    return "content-center";
  };

  return (
    <Grid fluid>
      <Row>
        {shortcuts.map((shortcut, index) => (
          <Col xs={24} sm={24} lg={8} key={shortcut.key}>
            <ShortCutPanel
              type={types.success}
              title={shortcut.title}
              paragraph={t("main-sidebar.admin")}
              href={shortcut.href}
              icon={shortcut.icon}
              className={edgeClass(index)}
            />
          </Col>
        ))}
      </Row>
    </Grid>
  );
};

export default AdminShortcuts;
